import type { Entity } from '@backstage/catalog-model';
import type { FC } from 'react';

import { ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';
import { tss } from 'tss-react/mui';

type Props = {
  coreProcess: Entity;
};

const useStyles = tss.create(({ theme }) => ({
  listItem: {
    paddingBottom: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: theme.spacing(2),
  },
  listItemAvatar: {
    '& img': {
      height: 32,
      width: 32,
    },
    'alignItems': 'center',
    'display': 'flex',
    'justifyContent': 'center',
    'marginLeft': theme.spacing(-1),
    'marginRight': 6,
  },
  listItemText: {
    ...theme.typography.link,
  },
}));

export const CoreProcessesDomain: FC<Props> = ({ coreProcess }) => {
  const { classes, cx } = useStyles();

  const catalogPath = `/catalog/default/domain/${coreProcess.metadata.name}`;

  return (
    <ListItem
      aria-label="Core Processes"
      className={classes.listItem}
      component={Link}
      to={catalogPath}
    >
      {coreProcess.spec?.logo && (
        <ListItemAvatar className={classes.listItemAvatar}>
          <img
            alt="Core Processes Logo"
            src={coreProcess.spec.logo.toString()}
          />
        </ListItemAvatar>
      )}
      <ListItemText
        primary={coreProcess.metadata.title}
        primaryTypographyProps={{
          className: cx(classes.listItemText),
        }}
      />
    </ListItem>
  );
};
